import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 152.06 145.77"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M130.74 21.35C116.55 7.17 97.66-.5 77.6.02l.15 6.76c18.38-.43 35.34 6.49 48.22 19.35 25.77 25.78 25.76 67.73 0 93.51-12.49 12.49-29.08 19.37-46.73 19.37-17.66 0-34.26-6.88-46.74-19.38-12.49-12.49-19.37-29.09-19.37-46.74 0-14.66 4.81-28.56 13.57-40.02v20.51h6.76V20.83H0v6.76h22.2C11.96 40.44 6.36 56.23 6.36 72.89c0 19.46 7.58 37.76 21.35 51.52 13.76 13.77 32.06 21.35 51.52 21.36 19.46 0 37.75-7.58 51.51-21.35 28.41-28.42 28.41-74.66 0-103.07Z",
  style: {"fill":"#181716"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }